<template>
	<div class="navbar">
		<div class="header">
			<a class="logo" target="_blank" href="https://www.emerson.com/en-us">
				<img src='../assets/images/emerson-logo.png' alt="emerson_logo" width="96px" />
			</a>
			<div class="dropdown">
				<a href="https://www.emerson.com/en-us/catalog/automation-solutions/measurement-instrumentation"><button class="dropbtn">PRODUCTS 
					<i class="fa fa-caret-down"></i>
				</button></a>
			</div> 
			<div class="dropdown2">
				<a href="https://www.emerson.com/en-us/support/software-downloads-drivers"><button class="dropbtn2">SOFTWARE 
					<i class="fa fa-caret-down"></i>
				</button></a>
			</div> 
			<div class="dropdown3">
				<a href="https://www.emerson.com/en-us/industries/automation"><button class="dropbtn3">INDUSTRIES 
					<i class="fa fa-caret-down"></i>
				</button></a>
			</div> 
			<div class="dropdown4">
				<a href="https://www.emerson.com/en-us/support"><button class="dropbtn4">SERVICES & SUPPORT 
					<i class="fa fa-caret-down"></i>
				</button></a>
			</div> 
			<div class="dropdown5">
				<a href="https://www.emerson.com/en-us/about-us"><button class="dropbtn5">COMPANY
					<i class="fa fa-caret-down"></i>
				</button></a>
			</div>
	   </div>
	</div>
</template>

<script>
export default {
  name:"EmersonHeader"
}
</script>
<style scoped>
@font-face {
    font-family: 'Noto Sans';
    src: url('../fonts/Noto_Sans/NotoSans-Light.ttf') format("truetype");
	
}

/* DROPDOWN CSS */
* {
	box-sizing: border-box;
  }
  
  body {
	margin: 0;
  }
  
  .navbar {
	overflow: hidden;
	background-color: #fff;
	font-family: 'Noto Sans' !important;
	font-weight: 600 !important;
	font-size: 0.780rem;
	letter-spacing: .08em;
	padding: 0px;
	box-shadow: 0 .25rem .75rem rgba(0, 0, 0, .05);
  }
  
  .navbar .logo {
	float: left;
	font-size: 16px;
	color: #262728;
	text-align: center;
	padding: 0px 0px 0px 0px;
	text-decoration: none;
	letter-spacing: .08em;
  }
  
  .dropdown {
	float: left;
	overflow: hidden;
  }

  .dropdown2 {
	float: left;
	overflow: hidden;
  }

  .dropdown3 {
	float: left;
	overflow: hidden;
  }

  .dropdown4 {
	float: left;
	overflow: hidden;
  }

  .dropdown5 {
	float: left;
	overflow: hidden;
  }
  
  .dropdown .dropbtn {
	font-size: 16px;  
	border: none;
	outline: none;
	color: black;
	padding: 20px 44px;
	background-color: inherit;
	font: inherit;
	margin: 0;
	letter-spacing: .08em;
  }

  .dropdown2 .dropbtn2 {
	font-size: 16px;  
	border: none;
	outline: none;
	color: black;
	padding: 20px 0px;
	background-color: inherit;
	font: inherit;
	margin: 0;
	letter-spacing: .08em;
  }

  .dropdown3 .dropbtn3 {
	font-size: 16px;  
	border: none;
	outline: none;
	color: black;
	padding: 20px 44px;
	background-color: inherit;
	font: inherit;
	margin: 0;
	letter-spacing: .08em;
  }

  .dropdown4 .dropbtn4 {
	font-size: 16px;  
	border: none;
	outline: none;
	color: black;
	padding: 20px 0px;
	background-color: inherit;
	font: inherit;
	margin: 0;
	letter-spacing: .08em;
  }

  .dropdown5 .dropbtn5 {
	font-size: 16px;  
	border: none;
	outline: none;
	color: black;
	padding: 20px 44px;
	background-color: inherit;
	font: inherit;
	margin: 0;
	letter-spacing: .08em;
  }
  
  .navbar, .dropdown:hover .dropbtn {
	background-color: white;
	color: #004b8d;
	text-decoration: underline;
	text-underline-offset: 20px;
	text-decoration-thickness: 3px;
	font-weight: 600;
  }

  .dropdown2:hover .dropbtn2 {
	background-color: white;
	color: #004b8d;
	text-decoration: underline;
	text-underline-offset: 20px;
	text-decoration-thickness: 3px;
	font-weight: 600;
  }

  .dropdown3:hover .dropbtn3 {
	background-color: white;
	color: #004b8d;
	text-decoration: underline;
	text-underline-offset: 20px;
	text-decoration-thickness: 3px;
	font-weight: 600;
  }

  .dropdown4:hover .dropbtn4 {
	background-color: white;
	color: #004b8d;
	text-decoration: underline;
	text-underline-offset: 20px;
	text-decoration-thickness: 3px;
	font-weight: 600;
  }

  .dropdown5:hover .dropbtn5 {
	background-color: white;
	color: #004b8d;
	text-decoration: underline;
	text-underline-offset: 20px;
	text-decoration-thickness: 3px;
	font-weight: 600;
  }
  
  .dropdown-content {
	display: none;
	position: absolute;
	background-color: #fff;
	width: 100%;
	left: 0;
	top: 7.8%;
	box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
	z-index: 1;
	height: 54vh;
  }

  .dropdown-content2 {
	display: none;
	position: absolute;
	background-color: #fff;
	width: 100%;
	left: 0;
	top: 7.8%;
	box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
	z-index: 1;
	height: 54vh;
  }

  .dropdown-content3 {
	display: none;
	position: absolute;
	background-color: #fff;
	width: 100%;
	left: 0;
	top: 7.8%;
	box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
	z-index: 1;
	height: 54vh;
  }

  .dropdown-content4 {
	display: none;
	position: absolute;
	background-color: #fff;
	width: 100%;
	left: 0;
	top: 7.8%;
	box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
	z-index: 1;
	height: 54vh;
  }

  .dropdown-content5 {
	display: none;
	position: absolute;
	background-color: #fff;
	width: 100%;
	left: 0;
	top: 7.8%;
	box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
	z-index: 1;
	height: 54vh;
  }

  .dropdown-content .header {
	padding: 16px;
	color: black;
	background-color: #fff;
  }

  .dropdown-content2 .header {
	background: red;
	padding: 16px;
	color: black;
  }

  .dropdown-content3 .header {
	background: red;
	padding: 16px;
	color: black;
  }

  .dropdown-content4 .header {
	background: red;
	padding: 16px;
	color: black;
  }

  .dropdown-content5 .header {
	background: red;
	padding: 16px;
	color: black;
  }
  
  /*.dropdown:hover .dropdown-content{
	display: block;
  }

  .dropdown2:hover .dropdown-content2{
	display: block;
  }

  .dropdown3:hover .dropdown-content3{
	display: block;
  }

  .dropdown4:hover .dropdown-content4{
	display: block;
  }

  .dropdown5:hover .dropdown-content5{
	display: block;
  }*/
  
  /* Create three equal columns that floats next to each other */
  .products{
	padding-bottom: 7%;
	text-align: left;
	text-decoration: none;
	color: #262728;
	font-family: Sans-Serif;
	font-weight: 500;
	font-size: 0.710rem;
  }
   .links .products:hover{
	color: #004b8d;
	font-weight: 600;
	font-family: Sans-Serif;
	font-size: 0.710rem;
  }  
  .products:hover .arrow{
	border: solid #004b8d;
	border-width: 0 2px 2px 0;
	padding: 3px;
	float: right;
	transform: rotate(-45deg);
	-webkit-transform: rotate(-45deg);
  }
  .links{
	display: flex;
	flex-direction: column;
	padding-left: 58%;
  }
  .arrow {
	border: solid #9fa1a4;
	border-width: 0 2px 2px 0;
	padding: 3px;
	float: right;
	transform: rotate(-45deg);
	-webkit-transform: rotate(-45deg);
  }

  .cell2Header{
	text-align: left;
    font-size: 0.730rem;
    color: black;
    padding-top: 2%;
    font-weight: 600;
  }
  .productsLink{
	text-decoration: none;
	color: #262728;
	font-size: 0.710rem;
  }
  .productsLink:hover {
	text-decoration: underline;
	text-underline-offset: 2px;
	color: #004b8d;
	font-size: 0.710rem;
  }
  .productsLinkCTA{
	color: #004b8d !important;
	font-family: sans-serif !important;
  }
  .productsLinkCTA .arr{
	color: #004b8d;
	font-size: 1.2rem;
	transition: 0.1s ease-in;
	display: inline-block;
	padding-left: 2%;
  }
  .productsLinkCTA:hover .arr{
	transform: translateX(30%);
  }
  .vl {
	border-left: 1px solid #c9cacc;
    height: 394px;
    position: absolute;
    margin-left: 32%;
    margin-top: -1%;
  }
  
  
 /* .column {
	float: left;
	width: 33.33%;
	padding: 10px;
	background-color: #ccc;
	height: 250px;
  }

  .column1 {
	float: left;
	width: 33.33%;
	padding: 10px;
	background-color: #fff;
	height: 250px;
  }
  
  .column a {
	float: none;
	color: black;
	padding: 16px;
	text-decoration: none;
	display: block;
	text-align: left;
  }

  .column1 a {
	float: none;
	color: black;
	padding: 16px;
	text-decoration: none;
	display: block;
	text-align: left;
  }
  
  .column a:hover {
	background-color: #ddd;
  }*/
  
  /* Clear floats after the columns */
  .row:after {
	content: "";
	display: table;
	clear: both;
  }
  
  /* Responsive layout - makes the three columns stack on top of each other instead of next to each other */
  @media screen and (max-width: 600px) {
	.column {
	  width: 100%;
	  height: auto;
	}
  }
  .header{
	padding-left: 19%;
  }

</style>